module.exports = __webpack_public_path__ + "static/media/checkbox_default.052d5701.svg";